import PatientCardComponent from "@/components/practitioner/PatientCard";

export default function PatientCard() {
  return (
    <div className="w-full flex justify-center h-full items-center">
      <PatientCardComponent />
    </div>
  );
}
